module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-5.jpg?6e8b9269";